import apiFetech from "../configs/axios";
import { API_CATEGORIS_URL } from "../constants/urls";

export class CategoryServices {
  // ** Get All Categoris
  static getAll() {
    var config = {
      method: "get",
      url: API_CATEGORIS_URL
    };
    return apiFetech(config);

    // return new Promise((resolve, reject) => {
    //   const list = [];
    //   for (let index = 1; index < 10; index++) {
    //     list.push({
    //       id: index,
    //       name: "أطباق فلسطينية",
    //       mainImage: require('../assets/images/images-demo/img-bg-meals.png'),
    //       image: require('../assets/images/images-demo/img-category.png')
    //     });
    //   }
    //   resolve({ data: list });
    // });
  }
}
